import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// declare var __webpack_public_path__: string;

if (environment.production) {
  enableProdMode();
  // __webpack_public_path__ = '/Style Library/TRADE-DASHBOARD/';
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
